import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/es6.symbol";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es6.object.assign";
import "core-js/modules/es6.function.name";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import staticQueryData from "../../../../../public/static/d/3727815696.json";
import React, { useContext, useMemo } from 'react';
var Context = React.createContext(null);
export var usePageData = function usePageData() {
  return useContext(Context);
};
export var baseFragment = "3145988255";
export var pagesFragment = "1794458575";

function DataProvider(props) {
  var data = staticQueryData.data;
  var context = useMemo(function () {
    return {
      pages: data.pages.nodes.filter(function (n) {
        var _n$docpocalypse;

        return (_n$docpocalypse = n.docpocalypse) === null || _n$docpocalypse === void 0 ? void 0 : _n$docpocalypse.title;
      }).map(function (d) {
        return {
          path: d.path,
          title: d.docpocalypse.title
        };
      }),
      api: data.api.nodes.map(function (_ref) {
        var name = _ref.name,
            rest = _objectWithoutPropertiesLoose(_ref, ["name"]);

        return _objectSpread({
          path: "/api/" + name,
          title: name
        }, rest);
      })
    };
  }, [data]);
  return /*#__PURE__*/React.createElement(Context.Provider, Object.assign({
    value: context
  }, props));
}

export default DataProvider;